<template>
        <div class="swiper-container">
            <div class="swiper-wrapper">
                <div 
                    class="swiper-slide"
                    v-for="v in exampleList" 
                    :key="v.id"
                >
                <router-link 
                    class="link"
                    :to="v.link"
                >
                    <div class="image-box"><img :src="v.mobimage"></div>
                    <p class="date">{{v.date}}</p>
                    <p class="text">{{v.title}}</p>
                </router-link>
                </div>
            </div>
        </div>
</template>
<script>

import Swiper from 'swiper'
    
export default {
    name: 'SwiperImagesFreeX',
    props: {
        exampleList: Array
    },
    data: function () {
      return {
            swiper: {
                banner: null
            }
      }
    },
    updated: function () {

    },
    mounted() {
        this.swiper.banner = new Swiper('.swiper-container',{
            freeMode : true,
            slidesPerView: 'auto'
        })
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>